'use client';

import { useEffect } from 'react';

import type { SsrDebugEntry } from '@/shared/api/ssr-debug';

type SsrDebugConsoleClientProps = {
	entries: SsrDebugEntry[];
};

/** Печатает в browser DevTools массив SSR request/response. */
export function SsrDebugConsoleClient({ entries }: SsrDebugConsoleClientProps) {
	useEffect(() => {
		console.log('[algocode-ssr-debug]', entries);
	}, [entries]);

	return null;
}
